import type { ReactNode } from "react";
import { ScrollView } from "react-native";
import { StyleSheet } from "react-native-unistyles";
import { Text, View } from "@src/components";
import { sizes } from "@src/constants/sizes";

interface PatriotToolsPageProps {
  /** Omit where the header breadcrumb already says what the page is. */
  readonly title?: string;
  readonly subtitle?: string;
  readonly titleAccessory?: ReactNode;
  readonly children: ReactNode;
}

export function PatriotToolsPage({ title, subtitle, titleAccessory, children }: PatriotToolsPageProps) {
  return (
    <ScrollView style={styles.scroll} contentContainerStyle={styles.content}>
      <View gap="4xl">
        {(title !== undefined || subtitle !== undefined) && (
          <View gap="xs">
            {title !== undefined && (
              <View flexDirection="row" alignItems="center" gap="lg">
                <Text textStyle="lg/semibold" color="text">
                  {title}
                </Text>
                {titleAccessory}
              </View>
            )}
            {subtitle !== undefined && (
              <Text textStyle="sm/regular" color="textMuted">
                {subtitle}
              </Text>
            )}
          </View>
        )}
        {children}
      </View>
    </ScrollView>
  );
}

const styles = StyleSheet.create((theme) => ({
  scroll: { flex: 1 },
  content: {
    padding: theme.spacing.xl,
    maxWidth: sizes.webReportMaxWidth,
    width: "100%",
  },
}));
